import { render, staticRenderFns } from "./menuGroupList.vue?vue&type=template&id=173d7bdb&scoped=true"
import script from "./menuGroupList.vue?vue&type=script&lang=js"
export * from "./menuGroupList.vue?vue&type=script&lang=js"
import style0 from "./menuGroupList.vue?vue&type=style&index=0&id=173d7bdb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173d7bdb",
  null
  
)

export default component.exports